import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-ib-nav',
  templateUrl: './ib-nav.component.html',
  standalone: false,
})
export class IbNavComponent {
  @Input() active = 'Shows'
}
